import Vue from 'vue'
import iView from 'iview'
import extend from './libs/extend'
import router from './router'
import store from './store'
import './libs/date'
import './libs/filter'
import './components/Dialog'
import './assets/styles/override.less'
import './assets/styles/base.less'
import app from './app.vue'

Vue.config.productionTip = false
Vue.use(iView)
Vue.use(extend)

new Vue({
  router,
  store,
  render: h => h(app),
}).$mount('#app')
